<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.287 8.27657L15.3362 7.41173L12.6761 2.01876C12.6034 1.8711 12.4839 1.75157 12.3362 1.67891C11.9659 1.4961 11.5159 1.64845 11.3307 2.01876L8.67059 7.41173L2.71981 8.27657C2.55574 8.30001 2.40574 8.37735 2.2909 8.49454C2.15206 8.63724 2.07555 8.82923 2.07819 9.02831C2.08083 9.22739 2.16239 9.41728 2.30496 9.55626L6.61043 13.7539L5.59324 19.6813C5.56939 19.8191 5.58465 19.961 5.63729 20.0906C5.68993 20.2203 5.77784 20.3326 5.89106 20.4148C6.00428 20.497 6.13828 20.5459 6.27785 20.5558C6.41743 20.5658 6.557 20.5364 6.68074 20.4711L12.0034 17.6727L17.3261 20.4711C17.4714 20.5484 17.6401 20.5742 17.8018 20.5461C18.2097 20.4758 18.4839 20.0891 18.4136 19.6813L17.3964 13.7539L21.7018 9.55626C21.819 9.44142 21.8964 9.29142 21.9198 9.12735C21.9831 8.7172 21.6972 8.33751 21.287 8.27657Z"
      :fill="colors[color]"
    />
  </svg>
</template>
<script>
export default {
  name: "starIcon",
  props: ["color"],
  data() {
    return {
      colors: {
        yellow: "#FBBF25",
        blue: "#66AEDF",
        red: "#F55454",
        orange: "#FFA451  ",
      },
    };
  },
};
</script>
